<template>
  <div class="provider-list-item">
    <img class="logo" :src="iconUrl" />
    <div class="meta">
      <div class="row">
        <div class="provider-column">
          <router-link class="name" :to="route">{{ nameOnSap }}</router-link>
        </div>
        <div class="provider-column">
          <router-link class="name" :to="route">{{ name }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["iconUrl", "name", "nameOnSap", "route"],
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

$logoSize: 32px;

.provider-list-item {
  display: grid;
  grid-template-columns: $logoSize auto;
  align-items: center;
  border-top: $border;
  border-bottom: $border;
  padding: ($space / 2) $space;

  > .logo {
    display: block;
    border-radius: 8px;
    width: $logoSize;
    height: $logoSize;
  }

  > .meta {
    padding-left: $space;
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .row {
    display: flex;
    gap: $space / 2;
    width: 100%;
  }

  .provider-column {
    flex: 1;
  }
}

.meta > .name {
  line-height: 1.6;
  display: inline-block;
  color: inherit;

  &:hover {
    color: black;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/providers/components/ProviderListItem.vue